import { Component, OnInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: []
})
 
 

export class HeaderComponent implements OnInit {
  openMenu:boolean= false;
  constructor() { }

  ngOnInit() {


  }
  open(){
  	if(!this.openMenu){
  		this.openMenu = true;
  	}
  	else{
  		this.openMenu = false;
  		$('nav > ul > li.itempadre > ul.submenu').removeClass('open')
  		$('nav').height(0);
  	}
  }
}
